import { registrationConfig } from "@/helpers/config";
import { reactive, toRefs } from "@vue/composition-api";

let memberDetails = null;

export function useMemberDetails() {
  let member = (window.Distinction && window.Distinction.member) || {};

  memberDetails =
    memberDetails ||
    reactive({
      firstName: member.FirstName || "",
      memberId: member.MemberId || "",
      isMember: !!(window.Distinction && window.Distinction.member),
      membershipType: member.MembershipType || "",
      membershipStatusType: member.MembershipStatus || "",
      paymentUrl: "",
      lastName: member.LastName || "",
      middleNames: member.MiddleNames || "",
      street: member.Address1 || "",
      town: member.AddressTown || "",
      county: member.AddressCounty || "",
      postCode: member.AddressPostcode || "",
      country: member.AddressCountry || "",
      title: member.Title || "",
      mobilePhone: member.MobilePhone?.replace(/\s+/g, "") || "",
      homePhone: member.HomePhone?.replace(/\s+/g, "") || "",
      workPhone: member.WorkPhone?.replace(/\s+/g, "") || "",
      hcpcNumber: member.HcpcNumber || "",
      membershipNumber: member.MembershipNumber || "",
      dateOfBirth: member.DateOfBirth || "",
      existing: false,
      lapsed: false,
      isActivating: registrationConfig.isActivating,
      isActivated: registrationConfig.isActivating,
      course: member.Course || null,
      startDate: member.TrainingStarted || null,
      lengthOfCourse: member.LengthOfCourse || 1,
      yearOfStudy: member.PointOfEntry || "",
      discipline: member.Discipline || "",
      qualificationOnEntry: member.QualificationOnEntry || "",
      fullPartTime: member.FullPartTime || "",
      awaitingPaymentConfirmation: member.AwaitingPaymentConfirmation,
      isVerified: member.IsVerified || false,
      userName: member.UserName || "",
      emailType: member.EmailType || "",
      workEmail: member.WorkEmail || "",
      whereFound: member.WhereFound || "",
      whereFoundOther: member.WhereFoundOther || "",
      dateQualified:
        member.DateQualified !== "0001-01-01T00:00:00"
          ? member.DateQualified
          : "",
      isAgencyWorker: member.IsAgencyWorker || false,
      expectedQualified:
        member.ExpectedQualified !== "0001-01-01T00:00:00"
          ? member.ExpectedQualified
          : "",
      hpcpNumber: member.HcpcNumber || "",

      university: member.EducationCentre || null,
      universityOtherCountry: member.EducationCentreOtherCountry || "",
      universityOtherName: member.EducationCentreOtherName || "",

      // DEI
      gender: member.MemberGender || "",
      ethnicity: member.Ethnicity || "",
      nationality: member.Nationality || "",
      hasDisability: member.HasDisability || false,
    });

  function setMemberUserNameData(userName) {
    memberDetails.userName = userName;
  }

  function setWhereFound(whereFound, whereFoundOther) {
    memberDetails.whereFound = whereFound;
    memberDetails.whereFoundOther = whereFoundOther;
  }

  function setUniversity(
    university,
    universityOtherCountry,
    universityOtherName,
  ) {
    memberDetails.university = university;

    memberDetails.universityOtherCountry =
      university === "QOUK" ? universityOtherCountry : "";
    memberDetails.universityOtherName =
      university === "QOUK" ? universityOtherName : "";
  }

  return {
    setMemberUserNameData,
    setWhereFound,
    setUniversity,
    ...toRefs(memberDetails),
  };
}
